import { CSpinner } from "@coreui/react";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  apiCall,
  API_BASE_URL,
  PAYMNET_CANCEL_URL,
  PG_BASE_URL_PAYMENT,
  PG_WT_CLIENT_CODE,
} from "src/_apiConfig/apiCall";

export default function SubmitLotTransferEMDPayment() {
  const formRef = useRef(null);
  const [checksum, setchecksum] = useState("");
  const [pgpath, setpgpath] = useState("");
  const { id, paymenttype } = useParams();

  const encrypted = window.atob(id);
  const encryptedpaymenttype = window.atob(paymenttype);

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  useEffect(() => {
    setpgpath(`${PG_BASE_URL_PAYMENT}/ws/payment`);

    const getDetails = async () => {
      const header = new Headers();
      header.append("Content-Type", "application/json");
      header.append("Accept", "application/json");
      var sessionID = makeid(35);
      const decid = window.btoa(encrypted);

      const responseData = await apiCall(
        `LotDetails/transferlotemdpayment?sessionId=${sessionID}&lotid=${encrypted}&returnUrl=${API_BASE_URL}PaymentResponse/transferlotemdpaymentresponse&cancelUrl=${PAYMNET_CANCEL_URL}?value=${decid}&paymenttype=${encryptedpaymenttype}`,
        "GET",
        header,
        null
      );
      const jsonobjData = await responseData.json();

      console.log(jsonobjData);
      if (responseData.status === 200) {
        setchecksum(jsonobjData);
        formRef.current.submit();
      }
    };

    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      {id ? (
        <form
          method="post"
          ref={formRef}
          action={pgpath}
          //action="https://demo.b2biz.co.in/ws/payment"
        >
          {/* <input type="hidden" name="walletClientCode" value="WT-1304" /> */}
          <input
            type="hidden"
            name="walletClientCode"
            value={PG_WT_CLIENT_CODE}
          />
          <input type="hidden" name="walletRequestMessage" value={checksum} />
        </form>
      ) : (
        <CSpinner
          className="spinner-grow col-6 offset-6 mt-6"
          color="success"
        />
      )}
    </>
  );
}
